import { render } from "./LoginForm.vue?vue&type=template&id=beeb034c&scoped=true"
import script from "./LoginForm.vue?vue&type=script&lang=ts"
export * from "./LoginForm.vue?vue&type=script&lang=ts"

import "./LoginForm.vue?vue&type=style&index=0&id=beeb034c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-beeb034c"

export default script